import React from "react"

class CheckSteps extends React.Component {
  componentDidMount() {
    const { steps, setSteps, value } = this.props
    value && steps && !steps.includes(value) && setSteps && setSteps(value)
  }
  render() {
    return <></>
  }
}

export default CheckSteps
